import axios from 'axios';
import ol from 'openlayers';
import {createOlStyleFunction, getLayer, getStyle, Reader} from "@nieuwlandgeo/sldreader/src";

const SldUtils = {
    applyExternalSld(map, vectorLayer, options) {
        if (options.layout) {
            axios.get(options.layout).then(response => {
                const sldObject = Reader(response.data);
                const sldLayer = getLayer(sldObject);
                const style = getStyle(sldLayer, sldLayer.name);
                const featureTypeStyle = style.featuretypestyles[0];

                //const viewProjection = map.getView().getProjection();
                vectorLayer.setStyle(createOlStyleFunction(featureTypeStyle, {
                    // Use the convertResolution option to calculate a more accurate resolution.
                    convertResolutionBak: viewResolution => {
                        const viewCenter = map.getView().getCenter();
                        return ol.proj.getPointResolution(viewProjection, viewResolution, viewCenter);
                    },
                    // If you use point icons with an ExternalGraphic, you have to use imageLoadCallback to
                    // to update the vector layer when an image finishes loading.
                    // If you do not do this, the image will only become visible after the next pan/zoom of the layer.
                    imageLoadedCallback: () => {
                        vectorLayer.changed();
                    }
                }));
            });
        }
    }
};

export default SldUtils;
